var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "trs-simple-fade" } }, [
    !_vm.hasUserAccepted
      ? _c("div", { staticClass: "cookie-banner grid grid__custom-1" }, [
          _c("div", { staticClass: "grid--container" }, [
            _c("div", { staticClass: "cookie-banner--row grid--row" }, [
              _c(
                "div",
                { staticClass: "cookie-banner--message-col grid--col" },
                [_vm._t("default")],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "grid--col cookie-banner--actions cookie-banner--actions-col "
                },
                [
                  _vm._t("actions", [
                    _c(
                      "button",
                      {
                        staticClass:
                          "cookie-banner--button btn btn__small btn__has-grid",
                        on: { click: _vm.onConfirm }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.confirmLabel) +
                            "\n                        "
                        )
                      ]
                    )
                  ])
                ],
                2
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f230caa0", { render: render, staticRenderFns: staticRenderFns })
  }
}